import { ShellThemeProvider } from '@sede-enterprise/shell-ds-react-framework'
import { BrowserRouter as Router } from 'react-router-dom';
import React, { useCallback, useState, useContext } from 'react'
import Layout from './Layout';
import { Route } from 'react-router-dom/cjs/react-router-dom';
import './App.css'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import HomeContainer from './pages/home/HomeContainer';
import AnalysisContainer from './pages/analysis/AnalysisContainer';
import { CMLMain } from './pages/CMLDetails/CMLMain';
import { CLDetailsMain } from './pages/CLDetails/CLDetailsMain';
import AlertsMain from './pages/alerts/AlertsMain';
import StatisticsMain from './pages/statistics/StatisticsMain';
import AlertsReportData from './pages/alerts/AlertsReportData';
import ModelContainer from './pages/model/ModelContainer';
import CancuiContainer from './pages/cancui/CancuiContainer';
import { AuthenticatedTemplate, MsalProvider, UnauthenticatedTemplate, useMsalAuthentication } from "@azure/msal-react";
import { InteractionType } from '@azure/msal-browser';
import { CARMA_USER_ROLES, CANCUI_USER_ROLES, INT_USER_ROLES } from './util/constants';
import AuthProvider from './AuthProvider';
import { AuthContext } from './AuthProvider';


// unit context
export const UnitContext = React.createContext({
    units: false,
    toggleUnits: () => { },
});

export const ErrorContext = React.createContext({
    message: null,
    showAlert: () => { }
});

export const UserContext = React.createContext({
    userData: null,
    addUserData: () => { }
})

const App = ({ pca }) => {

    const [units, setUnits] = useState(false);
    const toggleUnits = (units) => {
        setUnits(units);
    }

    const [message, setMessage] = useState(null);
    const showAlert = useCallback((message) => {
        setMessage(message);
    }, []);
    const [userData, setUserData] = useState(null);
    const addUserData = useCallback((user) => {
        setUserData(user);
    }, []);

    return (
        <MsalProvider instance={pca}>
            <AuthProvider>
                <ShellThemeProvider theme='light'>
                    <UserContext.Provider value={{
                        userData: userData,
                        addUserData: addUserData
                    }}>
                        <ErrorContext.Provider value={{
                            message: message,
                            showAlert: showAlert
                        }}>
                            <UnitContext.Provider value={{
                                units: units,
                                toggleUnits: toggleUnits
                            }}>
                                <ApplicationRoutes userData={userData} />
                            </UnitContext.Provider>
                        </ErrorContext.Provider>
                    </UserContext.Provider>
                </ShellThemeProvider>
            </AuthProvider>
        </MsalProvider>
    )
}




function ApplicationRoutes({ userData }) {
    const {login, result, error} = useMsalAuthentication(InteractionType.Popup);
    // console.log('Authentication error:', error);
    const { isTokenReady, role } = useContext(AuthContext);
    const isCarmaUser = CARMA_USER_ROLES.includes(role) || false; // Check if user is CARMA User
    const isCancuiUser = CANCUI_USER_ROLES.includes(role) || false; // Check if user is CANCUI User
    const isIntUser = INT_USER_ROLES.includes(role) || false; // Check if user is Internal User
    return (
        <Router>
            <Layout>
                <UnauthenticatedTemplate>
                    <div style={{ marginTop: "20vh", textAlign: "center" }}>
                        <h2>Please wait while we sign you in!</h2>
                    </div>
                </UnauthenticatedTemplate>
               <AuthenticatedTemplate>
                    {!isTokenReady &&
                        <div style={{ marginTop: "20vh", textAlign: "center" }}>
                            <h2>Setting up your session, please wait...</h2>
                        </div>
                    }
                    {isTokenReady && 
                        <>
                        {(isIntUser || isCarmaUser) && <div style={{ width: "100%" }}>
                            <Route exact path='/' component={HomeContainer} />
                            <Route path="/home" component={HomeContainer} />
                            <Route path="/cmls" component={CMLMain} />
                            <Route path="/cls" component={CLDetailsMain} />
                            <Route path="/alerts" component={AlertsMain} />
                            <Route path="/alertsReport/:id/:start/:end/:site/:category/:duration?" component={AlertsReportData} />
                            <Route path="/analysis" component={AnalysisContainer} />
                            {isIntUser && <Route path="/statistics" component={StatisticsMain} />}
                            <Route path="/models" component={ModelContainer} />
                        </div>}
                        {(isIntUser || isCancuiUser) && <div style={{ width: "100%" }}>
                            <Route path="/cancui" component={CancuiContainer} />
                        </div>}
                        </>
                    }
                </AuthenticatedTemplate>
                <ToastContainer position="bottom-center" hideProgressBar
                    style={{ width: "fit-content" }} id="app-id-1" />
            </Layout>
        </Router>
    )
}

export default App